import { render, staticRenderFns } from "./WithdrawalDialog.vue?vue&type=template&id=130e8bc2&scoped=true"
import script from "./WithdrawalDialog.vue?vue&type=script&lang=js"
export * from "./WithdrawalDialog.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalDialog.vue?vue&type=style&index=0&id=130e8bc2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e8bc2",
  null
  
)

export default component.exports